import * as actionTypes from '../constants/userActionTypes';

const defaultState = {
    projects: [],
    partners: [],
    reports: [],
    shortcuts: [],
    project_status: [],
    members: [],
    objectiveTypes: [],
    audienceTypes: [],
    loading: false,
    errors: {}
}

export const projectReducers = (state = defaultState, action = {}) => {
    switch (action.type) {
        // GET ACTIVITY SCHEDULE
        case actionTypes.GET_PROJECT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_PROJECT_SUCCESS:
            return {
                ...state,
                loading: false,
                projects: action.payload.data.projects ? action.payload.data.projects : [],
                totalUser: action.payload.total,
                count: action.payload.total
            }
        case actionTypes.GET_PROJECT_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.CLEAR_GET_PROJECTS:
            return {
                ...state,
                error: null,
                message: null
            }
        // PROJECT STATUS
        case actionTypes.GET_PROJECT_STATUS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_PROJECT_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                project_status: action.payload.data.project_status,
            }
        case actionTypes.GET_PROJECT_STATUS_FAIL:
            return {
                ...state,
                error: action.payload
            }
        // PROJECT EDIT
        case actionTypes.EDIT_PROJECT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.EDIT_PROJECT_SUCCESS:
            return {
                ...state,
                loading: false,
                project: action.payload.data,
            }
        case actionTypes.EDIT_PROJECT_FAIL:
            return {
                ...state,
                error: action.payload
            }
        // UPDATE PROJECT
        case actionTypes.UPDATE_PROJECT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.UPDATE_PROJECT_SUCCESS:
            console.log(action.payload, 'Reduceser')
            return {
                ...state,
                loading: false,
                // projects: state.projects.map(item => console.log(item.id === action.payload.data.id)),
                projects: state.projects.map(item => item.id === action.payload.data.id ? action.payload.data : item),
                message: action.payload.message,
                status: action.payload.success
            }
        case actionTypes.UPDATE_PROJECT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case actionTypes.UPDATE_PROJECT_RESET:
            return {
                ...state,
                error: null,
                message: null
            }
        // PROJECT CREATE
        case actionTypes.CREATE_PROJECT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.CREATE_PROJECT_SUCCESS:
            return {
                ...state,
                loading: false,
                message: action.payload?.message,
                errors: {},
                projects: [...state.projects, action.payload?.data],
            }
        case actionTypes.CREATE_PROJECT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case actionTypes.CLEAR_CREATE_PROJECT:
            return {
                ...state,
                error: null,
                message: null
            }

        case actionTypes.GET_CAMPAIGN_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_CAMPAIGN_SUCCESS:
            return {
                ...state,
                loading: false,
                campaigns: action.payload.data,
            }
        case actionTypes.GET_CAMPAIGN_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.CLEAR_GET_CAMPAIGN:
            return {
                ...state,
                error: null,
                message: null
            }
        case actionTypes.GET_PROJECT_SCHEDULE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_PROJECT_SCHEDULE_SUCCESS:
            return {
                ...state,
                loading: false,
                project_schedule: action.payload.data,
            }
        case actionTypes.GET_PROJECT_SCHEDULE_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.CLEAR_GET_PROJECT_SCHEDULE:
            return {
                ...state,
                error: null,
                message: null
            }
        // PROJECT MEMBERS
        case actionTypes.GET_PROJECT_MEMBER_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_PROJECT_MEMBER_SUCCESS:
            return {
                ...state,
                loading: false,
                members: action.payload.data,
            }
        case actionTypes.GET_PROJECT_MEMBER_FAIL:
            return {
                ...state,
                error: action.payload
            }
        // PROJECT OBJECTIVE TYPES
        case actionTypes.PROJECT_OBJECTIVE_TYPES_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.PROJECT_OBJECTIVE_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                objectiveTypes: action.payload.data.objective_types,
            }
        case actionTypes.PROJECT_OBJECTIVE_TYPES_FAIL:
            return {
                ...state,
                error: action.payload
            }
        // PROJECT AUDINCE TYPES
        case actionTypes.PROJECT_AUDIENCE_TYPES_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.PROJECT_AUDIENCE_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                audienceTypes: action.payload.data.audience_types,
            }
        case actionTypes.PROJECT_AUDIENCE_TYPES_FAIL:
            return {
                ...state,
                error: action.payload
            }
        
        // GET PROJECT SUPPORTING DOCS
        case actionTypes.GET_PROJECT_SUPPORTING_DOCS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_PROJECT_SUPPORTING_DOCS_SUCCESS:
            return {
                ...state,
                loading: false,
                supportingDocs: action.payload.data ? action.payload.data : [],
            }
        case actionTypes.GET_PROJECT_SUPPORTING_DOCS_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.CLEAR_GET_PROJECT_SUPPORTING_DOCS:
            return {
                ...state,
                error: null,
                message: null
            }
        
        // get Project Timelines
         case actionTypes.GET_PROJECT_TIMELINES_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_PROJECT_TIMELINES_SUCCESS:
            return {
                ...state,
                loading: false,
                projectTimelines: action.payload.data ? action.payload.data : [],
            }
        case actionTypes.GET_PROJECT_TIMELINES_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.CLEAR_GET_PROJECT_TIMELINES:
            return {
                ...state,
                error: null,
                message: null
            }

        // Project limition
        case actionTypes.GET_PROJECT_LIMIT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_PROJECT_LIMIT_SUCCESS:
            return {
                ...state,
                loading: false,
                projectLimit: action.payload.data ? action.payload.data : [],
            }
        case actionTypes.GET_PROJECT_LIMIT_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.CLEAR_GET_PROJECT_LIMIT:
            return {
                ...state,
                error: null,
                message: null
            }
        // Project Job Number
        case actionTypes.CHECK_USER_BY_EMAIL_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.CHECK_USER_BY_EMAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                userEmails: action.payload.data ? action.payload.data : [],
            }
        case actionTypes.CHECK_USER_BY_EMAIL_FAIL:
            return {
                ...state,
                error: action.payload
            }
        case actionTypes.CHECK_USER_BY_EMAIL_RESET:
            return {
                ...state,
                error: null,
                userEmails: null,
                message: null
            }
        // Project Job Number
        case actionTypes.GET_PROJECT_APPROVERS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_PROJECT_APPROVERS_SUCCESS:
            return {
                ...state,
                loading: false,
                projectApprovers: action.payload.data ? action.payload.data : [],
            }
        case actionTypes.GET_PROJECT_APPROVERS_FAIL:
            return {
                ...state,
                error: action.payload
            }
        default:
            return state;
    }
}